(function (angular) {
  "use strict";

  angular.module("app").service("EventOrdersApi", EventOrdersApi);

  EventOrdersApi.$inject = [
    "settings",
    "$resource",
    "extendResource",
    "EventsApi",
  ];

  function EventOrdersApi(settings, $resource, extendResource, EventsApi) {
    /**
     * Adds additional properties to the model
     * @return {this}
     */
    function transform() {
      // transform included event
      if (this.event) {
        this.event = new EventsApi(this.event).transform();
      }

      // add attendance_formatted
      if (this.attended) {
        switch (this.attended) {
          case "No":
            this.attended_formatted = "Not Attending";
            break;
          case "Yes":
            this.attended_formatted = "Attending";
            break;
          case null:
          case "Pending":
          default:
            this.attended_formatted = "Unknown Attendance";
        }
      }

      this.subevent_ids = this.subevents.map(function (subevent) {
        return subevent.id;
      });

      return this;
    }

    var resource = $resource(
      settings.apiBase + "/event-orders/:id",
      {},
      {
        get: {
          method: "GET",
          responseType: "json",
          transformResponse: function (response) {
            if (typeof response === "string") {
              response = JSON.parse(response);
            }

            if (Array.isArray(response.data)) {
              angular.forEach(response.data, function (item) {
                transform.call(item);
              });
            } else {
              if (response.data) {
                transform.call(response.data);
              }
            }

            return response;
          },
        },
        reserve: {
          method: "POST",
        },
        cost: {
          method: "GET",
          url: settings.apiBase + "/event-orders/cost",
        },
      },
    );

    resource.prototype.transform = transform;

    return extendResource(resource);
  }
})(angular);
